import React from "react"
import styles from "./styles.module.scss"
import { Button, Card, CardProps } from "antd"
import { IMonitor } from "pages/events/monitors/types"
import { UseMutationResult } from "@tanstack/react-query"
import { IApplyRequestBody } from "pages/events/monitors/queries"
import { useEvent } from "pages/events/queries"
import { useEventId } from "pages/events"
import { ReactComponent as CheckIcon } from "assets/icons/check.svg"
import { ReactComponent as PlayIcon } from "assets/icons/refresh.svg"
import { ReactComponent as PauseIcon } from "assets/icons/pause.svg"
import { ReactComponent as LeaveIcon } from "assets/icons/leave.svg"
import { ReactComponent as PhoneIcon } from "assets/icons/phone.svg"
import { ReactComponent as DeleteIcon } from "assets/icons/delete.svg"
interface Props extends CardProps {
  item: IMonitor
  isLoading: boolean
  applyTransition: UseMutationResult<
    unknown,
    unknown,
    IApplyRequestBody,
    unknown
  >
  transitionModal: {
    open: (data?: { transition: string; monitorId: string }) => void
    onClose: () => void
    isOpen: boolean
    data?: {
      transition: string
      monitorId: string
    }
  }
  openPhoneModal: (monitorPerson: IMonitor["person"]) => void
  unassignMonitorModal: (presenceId: string) => void
}

const MonitorItem: React.FC<Props> = ({
  item,
  transitionModal,
  applyTransition,
  isLoading,
  openPhoneModal,
  unassignMonitorModal,
}) => {
  const eventId = useEventId()
  const event = useEvent(eventId!)
  return (
    <Card className={styles.monitorCard}>
      <Card.Grid hoverable={false} style={{ width: "30%" }}>
        <p>{item.person.name}</p>
      </Card.Grid>
      <Card.Grid
        hoverable={false}
        style={{
          width: "70%",
          display: "flex",
          alignItems: "center",
          flexWrap: "wrap",
          rowGap: "var(--size-2)",
        }}
      >
        <Button
          className={styles.iconButton}
          onClick={() => openPhoneModal(item.person)}
          icon={<PhoneIcon />}
        />
        {item.transitions?.find((e) => e.name === "planned->checkin") && (
          <Button
            disabled={isLoading || event.data?.status === "approved"}
            className={styles.iconButton}
            onClick={() =>
              transitionModal.open({
                transition: `${item.status}->checkin`,
                monitorId: item.id,
              })
            }
            loading={
              isLoading && applyTransition.variables?.monitorId === item.id
            }
            icon={<CheckIcon />}
          />
        )}
        {item.transitions?.find((e) => e.name === "pause->resume") && (
          <Button
            disabled={isLoading || event.data?.status === "approved"}
            onClick={() =>
              transitionModal.open({
                transition: `${item.status}->resume`,
                monitorId: item.id,
              })
            }
            loading={
              isLoading && applyTransition.variables?.monitorId === item.id
            }
            className={styles.iconButton}
            icon={<PlayIcon />}
          />
        )}

        {item.transitions?.some((e) =>
          ["resume->pause", "checkin->pause", "resume->checkout"].includes(
            e.name
          )
        ) && (
          <Button
            disabled={isLoading || event.data?.status === "approved"}
            className={styles.iconButton}
            loading={
              isLoading &&
              applyTransition.variables?.monitorId === item.id &&
              applyTransition.variables?.transition === `${item.status}->pause`
            }
            onClick={() =>
              transitionModal.open({
                transition: `${item.status}->pause`,
                monitorId: item.id,
              })
            }
            icon={<PauseIcon />}
          />
        )}
        {item.transitions?.some((e) =>
          ["checkin->checkout", "pause->checkout", "resume->checkout"].includes(
            e.name
          )
        ) && (
          <Button
            disabled={isLoading || event.data?.status === "approved"}
            className={styles.iconButton}
            loading={
              isLoading &&
              applyTransition.variables?.monitorId === item.id &&
              applyTransition.variables?.transition ===
                `${item.status}->checkout`
            }
            onClick={() =>
              transitionModal.open({
                transition: `${item.status}->checkout`,
                monitorId: item.id,
              })
            }
            icon={<LeaveIcon />}
          />
        )}
        {item.status === "checkout" && <Button disabled icon={<LeaveIcon />} />}
        {item.attendance_on_execution && (
          <Button
            className={styles.iconButton}
            onClick={() => unassignMonitorModal(item.id)}
            icon={<DeleteIcon />}
          />
        )}
      </Card.Grid>
    </Card>
  )
}

export default MonitorItem
